import * as React from 'react'
import { List, Datagrid, TextField, ReferenceField } from 'react-admin'

export const GroupList = (props) => (
  <List {...props}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <ReferenceField source="ownerId" reference="participant">
        <TextField source="id" />
      </ReferenceField>
      <TextField source="name" />
      <TextField source="city" />
      <TextField source="image" />
      <TextField source="description" />
    </Datagrid>
  </List>
)
